// index.js

import { createRouter, createWebHistory } from 'vue-router';
import { authStore } from '@/authStore.js';
import axios from 'axios'; // 确保引入axios，如全局已挂载可替换为全局请求

// 试用缓存key，和页面保持统一
const TRY_CACHE_KEY = 'detail_try_cache';
// 试用资格接口地址
const TRY_API_URL = '/api/z_model/check-detail-try';

// 优化1：核心页面改为懒加载（仅访问时加载）
const routes = [
  { path: '/', component: () => import('@/views/Cre-detail.vue') },
  { path: '/home', component: () => import('@/views/HomeView.vue') },
  { path: '/password_reset/:uid/:token', component: () => import('@/views/HomeView.vue') },
  { path: '/login', component: () => import('@/components/User-Login.vue') },
  { path: '/auth', component: () => import('@/views/AuthView.vue') },
  { path: '/useragreement', component: () => import('@/views/User-Agreement.vue') },
  { path: '/userprivacypolicy', component: () => import('@/views/User-PrivacyPolicy.vue') },
  { path: '/code', component: () => import('@/components/User_WechatCode.vue') },

  // 优化2：Cre-view 作为独立页面（懒加载）
  { path: '/create', component: () => import('@/views/Cre-view.vue') },
  { path: '/detail', component: () => import('@/views/Cre-detail.vue') },

  // 优化3：Toolbox 布局嵌套（公共框架 + 子页面）
  {
    path: '/toolbox',
    component: () => import('@/views/Cre-Toolbox.vue'), // Toolbox 主布局
    children: [
      { path: 'matting', component: () => import('@/components/Cre-toolmatting.vue') },
      { path: 'super-resolution', component: () => import('@/components/Cre-toolSuperResolution.vue') },
      { path: 'translation', component: () => import('@/components/toolbox-translation.vue') },
      { path: 'whitemodel', component: () => import('@/components/toolbox-whitemodel.vue') },
      { path: 'watermark', component: () => import('@/components/toolbox-RemoveWatermark.vue') },
      { path: 'videouper', component: () => import('@/components/toolbox-VideoUper.vue') },
      { path: 'matting-plus', component: () => import('@/components/toolbox-mattingplus.vue') },
      { path: 'super-resolution-plus', component: () => import('@/components/toolbox-SuperResolutionPlus.vue') },
      { path: 'translation-plus', component: () => import('@/components/toolbox-TranslationPlus.vue') },
    ]
  },

  // 优化4：AI设计师布局嵌套
  {
    path: '/designer',
    component: () => import('@/views/cre-designer.vue'),
    children: [
      { path: '', redirect: 'poster' },
      { path: 'poster', component: () => import('@/components/designer-poster.vue') },
      { path: 'migration', component: () => import('@/components/designer-migration.vue') },
      { path: 'scene', component: () => import('@/components/designer-scene.vue') },
      { path: 'changecolor', component: () => import('@/components/designer-changecolor.vue') },
      { path: 'filling', component: () => import('@/components/designer-filling.vue') },
      { path: 'texture', component: () => import('@/components/designer-texture.vue') },
    ]
  },

  {
    path: '/ai-photographer/image',
    component: () => import('@/views/cre-photographer-image.vue'),
    children: [
      { path: '', redirect: 'image-white' },
      { path: 'image-white', component: () => import('@/components/image-white.vue') },
      { path: 'image-scene', component: () => import('@/components/image-scene.vue') },
      { path: 'image-model', component: () => import('@/components/image-model.vue') },
      { path: 'image-shot', component: () => import('@/components/image-changeshot.vue') },
      { path: 'image-role', component: () => import('@/components/image-role-replace.vue') },
      { path: 'scene-replace', component: () => import('@/components/image-scene-replace.vue') },
    ]
  },

  {
    path: '/ai-photographer/video',
    component: () => import('@/views/Cre-Photographer-Video.vue'),
    children: [
      { path: '', redirect: 'imagetovideo' },
      { path: 'imagetovideo', component: () => import('@/components/video-ImageToVideo.vue') },
      { path: 'shortvideo', component: () => import('@/components/video-ShortVideo.vue') },
      { path: 'longvideo', component: () => import('@/components/video-LongVideo.vue') },
      { path: 'rolechange', component: () => import('@/components/video-RoleChange.vue') },
      { path: 'image-role', component: () => import('@/components/image-role-replace.vue') },
      { path: 'scenechange', component: () => import('@/components/video-SceneChange.vue') },
    ]
  },

  { path: '/assets', component: () => import('@/views/Cre-user-assets.vue') },
  { path: '/payment', component: () => import('@/components/User_Payment.vue') },
  { path: '/account', component: () => import('@/views/Cre-Account.vue') },
  { path: '/userset', component: () => import('@/components/Cre-AccountSet.vue') },
  { path: '/inspiration', component: () => import('@/views/Cre-Inspiration.vue') },
  { path: '/ai-photographer/video', component: () => import('@/components/ComingSoon.vue') },
  { path: '/ai-photographer/image', component: () => import('@/views/cre-photographer-image.vue') },
  { path: '/published-works', component: () => import('@/views/Cre-UserUpcenter.vue') },
  { path: '/invite', component: () => import('@/components/User-Invite.vue') },
  { path: '/messages', component: () => import('@/views/Cre-Messages.vue') },
  { path: '/splashad', name: 'SplashAd', component: () => import('@/components/Home-SplashAd.vue') },
  { path: '/alldata', component: () => import('@/views/All-Data.vue') },

  { path: '/:pathMatch(.*)*', component: () => import('@/views/Place_holder.vue') }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0, behavior: 'smooth' };
  }
});

// 导航守卫
router.beforeEach(async (to, from, next) => {
  if (!authStore._initialized) {
    await authStore.init();
    authStore._initialized = true;
  }

  const requiresAuthRoutes = ['/create', '/detail', '/toolbox', '/assets', '/account', '/designer'];
  const requiresAuth = requiresAuthRoutes.some(route => to.path.startsWith(route));

  if (authStore.isLoggedIn && (to.path === '/' || to.path === '/detail')) {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const res = await axios.get(TRY_API_URL, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        });
        if (res.data.code === 0) {
          localStorage.setItem(TRY_CACHE_KEY, JSON.stringify(res.data.data));
        } else {
          localStorage.removeItem(TRY_CACHE_KEY);
        }
      } catch (err) {
        console.warn('预加载试用资格失败', err);
      }
    }
  }

  // 无权限：唤起全局登录弹窗，强制跳首页，杜绝空白
  if (requiresAuth && !authStore.isLoggedIn) {
    authStore.openLoginModal();
    // 固定跳转首页，不使用from.path，首次新开页面也不会空白
    next('/');
  } else {
    next();
  }
});

if (!authStore._initialized) {
  authStore.init().catch(err => console.error('Auth store init failed:', err));
}

export default router;